import Base from "./Base";
import * as turf from '@turf/turf'
import * as helpers from '@turf/helpers'
import {TOOL_DRAW_LINE} from "./ToolType";
import SimpleEditToolBar from "../control/SimpleEditToolBar";
const POINT_LAYER_NAME = "DrawLineTool_POINT";
const LINE_LAYER_NAME = "DrawLineTool_LINE";


export default class DrawLineTool extends Base {
  /**
   *
   */
  constructor(options) {
    let params = {
      isBrokenLine: true,//绘制折线还是线段
      lineColor: "#fbb03b",//线的颜色
      lineWidth: 2,//线的宽度
      lineDasharray: [1, 1],//线型
      pointColor: "#fbb03b",//端点颜色
      pointSize: 4,//端点大小
      callBack: null,//绘制完成回调函数
      callBackName: null,//绘制完成回调地图事件名称
      errorCallBack: null,//错误回调函数
      moveCallBack: null,//绘制移动回调函数
      moveCallName: null,//绘制移动回调地图事件名称
      map: null,//地图实例
      showIcon: true,//是否展示图标
      iconCLassName: "iconfont-map map-icon-zhexian",//图标类名
      chineseName: "线",
      showLength: false,
      continueDraw:false,
      innerUse: false,
      showTool:false,//是否展示撤销工具条
      toolPosition:'top-right',//工具条位置,'top-left' ， 'top-right' ， 'bottom-left' ，和 'bottom-right' 。默认为 'top-right' 。
    }
    Object.assign(params, options)

    super(params.map, TOOL_DRAW_LINE, params);
    this.params = params;
    this.showTool=params.showTool;
    this.toolPosition=params.toolPosition;
    this.continueDraw=params.continueDraw;


  }

  start() {
    super.start();
    //改变鼠标样式
    this._defaultCursor = this.map.getCanvas().style.cursor;
    this.map.getCanvas().style.cursor = "crosshair";
    this.movePoint = null;
    //初始化三个点的数组
    this.points = [];//当前绘制点
    this.pointsRedo = [];//已撤销的点
    this.currentPoint = null;//鼠标当前点
    if(this.showTool){
      //显示工具条
      this.control=new SimpleEditToolBar(this._btnListener.bind(this));
      this.map.addControl(this.control, this.toolPosition)
    }
    this._addLayer();
    this._addEvent();

  }

  /**
   * 工具条点击回调
   * @param type
   * @private
   */
  _btnListener(type){
    switch (type){
      case "cancel":this.cancel();break;
      case "undo":this.undo();break;
      case "redo":this.redo();break;
      case "addPoint":this.addPoint();break;
      case "finish":this.drawFinish();break;
      default:break;
    }
  }
  /**
   * 取消绘制
   */
  cancel(){
    this.close();
    if(this.continueDraw){
      this.reset();
    }else {
      this.inActiveIcon()
    }
  }
  /**
   * 地图数据清空
   */
  reset(){
    this.points = [];//当前绘制点
    this.pointsRedo = [];//已撤销的点
    this.currentPoint = null;//鼠标当前点
    this.clearPopup();
    this._update();
  }
  /**
   * 重做点
   */
  redo(){
    if (this.pointsRedo.length === 0) {
      return
    }
    this.points.push(this.pointsRedo[this.pointsRedo.length - 1]);
    this.pointsRedo.splice(this.pointsRedo.length - 1, 1);
    this._update();
  }

  /**
   * 绘制点
   */
  undo(){
    if (this.points.length === 0) {
      return
    }
    this.pointsRedo.push(this.points[this.points.length - 1]);
    this.points.splice(this.points.length - 1, 1);
    this._update();
  }
  /**
   * 取屏幕中心点添加
   */
  addPoint(){
    this.points.push(this.map.getCenter().toArray())
    this._update();
  }

  _addLayer() {

    if (!this.map.getSource(POINT_LAYER_NAME)) {
      this.map.addSource(POINT_LAYER_NAME, {
        type: "geojson",
        data: helpers.featureCollection([]),
      });
    }
    if (!this.map.getSource(LINE_LAYER_NAME)) {
      this.map.addSource(LINE_LAYER_NAME, {
        type: "geojson",
        data: helpers.featureCollection([]),
      });
    }
    if (!this.map.getLayer(LINE_LAYER_NAME)) {
      this.map.addLayer({
        id: LINE_LAYER_NAME,
        type: "line",
        source: LINE_LAYER_NAME,
        layout: {},
        paint: {
          'line-color': this.params.lineColor,
          'line-width': this.params.lineWidth,
          'line-dasharray': this.params.lineDasharray
        }
      });
    }
    if (!this.map.getLayer(POINT_LAYER_NAME)) {
      this.map.addLayer({
        id: POINT_LAYER_NAME,
        type: "circle",
        source: POINT_LAYER_NAME,
        layout: {},
        paint: {
          'circle-color': this.params.pointColor,
          'circle-radius': this.params.pointSize,
          "circle-stroke-width":3,
          "circle-stroke-color":"#fff"
        },
      });
      this.map.on("click",POINT_LAYER_NAME,(e)=>{
        this._drawEndEvent(e)
      })
    }






  }

  //更新线绘制
  _update() {
    if(this.control){
      this.control.setPointLengthLine(this.points.length,this.pointsRedo.length)
    }


    let drawPoints = [].concat(this.points);
    if (this.movePoint) {
      drawPoints.push(this.movePoint)
    }


    let points = [];

    for (let i = 0; i < drawPoints.length; i++) {
      points.push(helpers.point(drawPoints[i]))
    }

    //绘制点
    if(this.movePoint){
      //在web，防止最后一个点阻挡点击事件
      this.map.getSource(POINT_LAYER_NAME).setData(helpers.featureCollection(points.slice(0,points.length-1)));
    }else {
      this.map.getSource(POINT_LAYER_NAME).setData(helpers.featureCollection(points));
    }


    if (drawPoints.length > 1) {
      let line = helpers.lineString(drawPoints);
      this.map.getSource(LINE_LAYER_NAME).setData(helpers.featureCollection([line]));

      if (this.params.moveCallBack) {
        this.params.moveCallBack(line);
      }
      if (this.params.moveCallName) {
        this.map.fire(this.params.moveCallName, line)
      }
      if (this.params.showLength) {
        this.addPopup(turf.length(line).toFixed(2) + "千米", turf.center(line))
      }
    }else {
      this.map.getSource(LINE_LAYER_NAME).setData(helpers.featureCollection([]));
    }

  }


  close(notClearMap = false) {
    this.clear(notClearMap);
    this.clearEvent();
    //移除编辑组件
    if(this.control){
      this.map.removeControl(this.control)
      this.control=null;
    }
  }

  clear(notClearMap = false) {
    this.clearMap(notClearMap);
    this.enableViewMap();
  }

  clearMap(notClearMap = false) {
    this.map.getCanvas().style.cursor = this._defaultCursor;


    //不清除地图选择绘制图层
    if (!notClearMap) {
      super.clearMap();
    }
    this.removeDrawLayer();
    this.clearPopup();
  }

  //移除绘制图层
  removeDrawLayer() {
    if (this.map.getLayer(LINE_LAYER_NAME)) {
      this.map.removeLayer(LINE_LAYER_NAME);
      this.map.off("click",POINT_LAYER_NAME)
      this.map.removeLayer(POINT_LAYER_NAME);
    }
    if (this.map.getSource(LINE_LAYER_NAME)) {
      this.map.removeSource(LINE_LAYER_NAME);
      this.map.removeSource(POINT_LAYER_NAME);
    }
  }

  clearEvent() {
    super.clearEvent();
    this.map.off("click", this._clickEvent);
    if(!this.isMobile){
      this.map.off("mousemove", this._moveEvent);
    }
    this.map.off("contextmenu", this._drawEndEvent);
  }

  _addEvent() {
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|OperaMini/i.test(navigator.userAgent);
    this._clickEvent = (e) => {
      if(e.defaultPrevented){return;}
      this.points.push([e.lngLat.lng, e.lngLat.lat]);
      this._update();

      //线段绘制完成事件
      if (!this.params.isBrokenLine && this.points.length > 1) {
        this.clearEvent();
        this._drawEndEvent(e);
      }
    }
    this.map.on('click', this._clickEvent)
    if(!this.isMobile){
      this._moveEvent = (e) => {
        if (this.points.length === 0) {
          return
        }
        this.movePoint = [e.lngLat.lng, e.lngLat.lat];
        this._update();
      }
      this.map.on("mousemove", this._moveEvent);
    }

    //双击或右键结束
    this._drawEndEvent = (e) => {
      this._preventDefault(e);
      this.drawFinish()
    }
    this.map.on("contextmenu", this._drawEndEvent);
  }
  drawFinish(){
    this.finish(this._getFeature());

    if(this.continueDraw){
      this.reset();
    }else {
      this.inActiveIcon();
      this.close()
    }
  }

  _getFeature() {
    return helpers.lineString(this.points);
  }
}



// WEBPACK FOOTER //
// ./src/tool/edit/DrawLineTool.js